(function () {
  function bindDialog(root) {
    var dialog = root.querySelector('[data-library-dialog]');
    var openBtn = root.querySelector('[data-library-open]');
    var form = root.querySelector('.library-request-dialog__form');
    if (!dialog || !openBtn) return;

    if (dialog.querySelector('.library-request-dialog__success')) {
      dialog.showModal();
    }

    var close = function () {
      dialog.close();
      openBtn.focus();
    };

    openBtn.addEventListener('click', function () {
      dialog.showModal();
    });

    dialog.querySelectorAll('[data-library-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        close();
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    if (form) {
      form.addEventListener('submit', function () {
        var title = (form.querySelector('[name="contact[book_title]"]') || {}).value || '';
        var author = (form.querySelector('[name="contact[book_author]"]') || {}).value || '';
        var notes = (form.querySelector('[name="contact[notes]"]') || {}).value || '';
        var body = form.querySelector('[name="contact[body]"]');
        if (!body) return;
        var lines = ['Book request from Library page', '', 'Title: ' + title];
        if (author) lines.push('Author: ' + author);
        if (notes) lines.push('Notes: ' + notes);
        body.value = lines.join('\n');
      });
    }
  }

  document.querySelectorAll('[data-library-page]').forEach(bindDialog);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-library-page]');
    if (root) bindDialog(root);
  });
})();
